
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";

import { Head } from "@/components/Head";
import { CustomersLogosSection } from "@/sections/CustomersLogosSection";
import { BrokenXDSection } from "@/sections/BrokenXDSection";
import { ConversionSection } from "@/sections/ConversionSection";
import { DescriptionSection } from "@/sections/DescriptionSection";
import { CTASection } from "@/sections/CTASection";

const OpenXdFileOldCorrupted = () => {
  const { t } = useTranslation();

  return (
    <>
      <Head
        pageNamespace="page/open-xd-file-old-corrupted"
        ogImage="/images/broken-xd-og-image.jpg"
      />

      <BrokenXDSection />

      <CustomersLogosSection isDarkMode />

      <DescriptionSection
        elements={[
          {
            title: t("section/description:elements.firstElement.title"),
            texts: [
              t("section/description:elements.firstElement.firstParagraph"),
              t("section/description:elements.firstElement.secondParagraph"),
            ],
            image: "/images/outdated-screenshot.png",
          },
          {
            title: t("section/description:elements.secondElement.title"),
            reverse: true,
            texts: [
              t("section/description:elements.secondElement.firstParagraph"),
            ],
            image: "/images/corrupted-screenshot.png",
          },
        ]}
      />

      <ConversionSection
        title={t("page/open-xd-file-old-corrupted:section/conversion.title")}
        elements={{
          from: {
            title: "Xd corrupted preview",
            image: "/images/corrupted-screenshot.png",
            iconType: "ADOBEXD",
          },
          to: {
            title: "Xd fixed preview",
            image: "/images/xd-preview.jpg",
            iconType: "ADOBEXD",
          },
        }}
      />

      <CTASection
        title={t("section/cta:titles.openXdFileCorrupted")}
        href="#BrokenXDSection"
        buttonLabel={t("section/cta:buttonUploadLabel")}
      />
    </>
  );
};

export default OpenXdFileOldCorrupted;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/open-xd-file-old-corrupted',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  